<h2>{{name}}</h2>
<hr/>
<p>{{desc}}</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>
<hr/>

<h5 class="mt-4">Example:</h5>

<div class="col-12 examples-table" *ngIf="true">
  <div class="row">
    <div class="col-12 code-box"><pre>{{instance2}}</pre></div>
  </div>
</div>

<div class="col-12 marT15">
  <ul class="list-unstyled table-list">
    <li class="list-header">
      <jb-list-header-col class="col-2" colTitle="view.common.username"   fieldName="username"   [orderConf]="orderConf"></jb-list-header-col>
      <jb-list-header-col class="col-3" jbTooltip="view.common.email" colTitle="view.common.email"      fieldName="email"      [orderConf]="orderConf"></jb-list-header-col>
      <jb-list-header-col class="col-2" jbTooltip="First name is unordered" colTitle="First Name"></jb-list-header-col>
      <!--<jb-list-header-col class="col-2" colTitle="Last Name"></jb-list-header-col>-->
      <jb-list-header-col class="col-2 center" colTitle="Status" [orderConf]="orderConf"></jb-list-header-col>
    </li>

    <li class="list-row" *ngFor="let userItem of usersList">
      <div class="col-2">{{userItem.username}}</div>
      <div class="col-3">{{userItem.email}}</div>
      <div class="col-2">{{userItem.first_name}}</div>
      <!--<div class="col-2">{{userItem.last_name}}</div>-->
      <jb-status-badge class="col-2" [jbStatus]="0"></jb-status-badge>
      <div class="col-3 text-right">
        <jb-btn jbType="delete" (jbClick)="userItem.$remove()"></jb-btn>
        <jb-btn jbType="edit"   (jbClick)="userItem.$save({ username: 'new value' })"></jb-btn>
      </div>
    </li>
  </ul>



</div>

<!--Applicable classes -->
<div class="row">
  <div class="col-12">
    <hr>
    <h5 class="mt-4">Applicable classes:</h5>
    <p>class="<b>center</b>" to center the text</p>
  </div>
</div>
